var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"d-lg-flex align-items-center justify-content-center"},[_c('h4',{staticClass:"font-weight-boldest text-center mb-0"},[_c('img',{style:(_vm.imageStyle),attrs:{"src":_vm.$options[_vm.name],"alt":"Salmon"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }